/**
 * 活动优先级控制枚举
 */
export enum PriorityEnum {
    /**
     * 头图模块
     */
    TITLE_IMAGE = 'TITLE_IMAGE',
    /**
     * 助力用户弹窗
     */
    ASSIST_USER_DIALOG = 'ASSIST_USER_DIALOG',
    /**
     * 访问引导弹窗
     */
    VISIT_GUIDE_DIALOG = 'VISIT_GUIDE_DIALOG',
    /**
     * 访问奖励弹窗
     */
    VISIT_PRIZE_DIALOG = 'VISIT_PRIZE_DIALOG',
    /**
     * 签到弹窗
     */
    SIGN_IN_DIALOG = 'SIGN_IN_DIALOG',
    /**
     * 重复任务自动领奖弹窗
     */
    REPEAT_TASK_AUTO_OBTAIN_PRIZE_DIALOG = 'REPEAT_TASK_AUTO_OBTAIN_PRIZE_DIALOG',
    /**
     * 金币投掷通知弹窗
     */
    THROW_COIN_NOTICE_DIALOG = 'THROW_COIN_NOTICE_DIALOG',
}
